import { PropTypes } from 'base/react-libs';
import { Button } from '@evertrue/et-components';

const CircleCheckToggle = ({ size = 'big', onClick = () => {}, checked = false }) => {
  return (
    <Button type="simple" data-testid="task-completion-toggle" onClick={onClick}>
      <div
        aria-label="task-completion-toggle"
        className={
          checked
            ? `checked-circle--clickable checked-circle--${size}`
            : `check-circle--clickable check-circle--${size}`
        }
      />
    </Button>
  );
};

CircleCheckToggle.propTypes = {
  size: PropTypes.string,
  onClick: PropTypes.func,
  checked: PropTypes.bool,
};

export default CircleCheckToggle;
